import { InvoiceDocument } from '@sparklayer-io/spark-dash-pages/components/document-graphics';
import { t } from 'i18next';
import type { I18nPrefix } from '../../../i18n/prefix';

const COMPONENT = 'features:home.components.upsell_plan_graphics' satisfies I18nPrefix;

const COMPANY_USERS = [
  { box: 46.5, arrow: 146 },
  { box: 240.5, arrow: 320 },
  { box: 434.5, arrow: 510.5 },
] as const;

const API_RESPONSE = [
  { line: '"api_settings": [', indent: false },
  { line: '"customer_group": "b2b_user",', indent: true },
  { line: '"pack_size": 6,', indent: true },
  { line: '"reserve_stock_quantity": 0,', indent: true },
  { line: '"min_order_quantity": 12,', indent: true },
  { line: '"max_order_quantity": 24,', indent: true },
] as const;

export function CompanyUsersGraphic() {
  return (
    <svg viewBox="0 0 640 380" aria-hidden="true" className="select-none">
      <rect
        x="129.5"
        y="49.5"
        width="379"
        height="81"
        rx="9"
        strokeWidth="3"
        className="fill-illustration-primary/10 stroke-illustration-secondary"
      />
      <g
        fill="none"
        strokeWidth="2.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="stroke-illustration-primary-text"
      >
        <circle cx="218.5" cy="78" r="5.3" />
        <circle cx="206" cy="84.5" r="3.8" />
        <circle cx="231" cy="84.5" r="3.8" />
        <path d="M209 103.5c0-6.3 4.3-11.3 9.5-11.3s9.5 5 9.5 11.3c-2.6 1.3-5.9 2-9.5 2s-6.9-.7-9.5-2z" />
        <path d="M208.6 95.4c-1-.4-2-.6-3.1-.6-3.2 0-5.9 2-6.6 4.8 2 .9 5.2 1.5 8.3 1.4" />
        <path d="M228.4 95.4c1-.4 2-.6 3.1-.6 3.2 0 5.9 2 6.6 4.8-2 .9-5.2 1.5-8.3 1.4" />
      </g>
      <text
        x="266"
        y="100"
        fontSize="28"
        fontWeight="600"
        className="fill-illustration-primary-text"
      >
        {t(`${COMPONENT}.company_users.company`)}
      </text>
      {COMPANY_USERS.map(({ box, arrow }, index) => (
        <g key={box}>
          <path
            d={`M${arrow} 163.5v56m-19-19 19 19 19-19`}
            fill="none"
            strokeWidth="4.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="stroke-spark-text-tertiary"
          />
          <rect
            x={box}
            y="253.5"
            width="161"
            height="76"
            rx="9"
            strokeWidth="3"
            className="fill-spark-surface stroke-spark-border-default"
          />
          <text
            x={box + 80.5}
            y="301.5"
            fontSize="28"
            fontWeight="600"
            textAnchor="middle"
            className="fill-spark-text-secondary"
          >
            {t(`${COMPONENT}.company_users.user`, { number: index + 1 })}
          </text>
        </g>
      ))}
    </svg>
  );
}

export function ApiAccessGraphic() {
  return (
    <svg viewBox="0 0 640 380" aria-hidden="true" className="select-none">
      <rect
        x="52.5"
        y="48.5"
        width="531"
        height="360"
        rx="11"
        strokeWidth="3"
        className="fill-spark-surface stroke-spark-border-default"
      />
      <path d="M54 129h528" fill="none" strokeWidth="2" className="stroke-spark-border-default" />
      <rect
        x="68.5"
        y="66.5"
        width="260"
        height="47"
        rx="9"
        strokeWidth="2.5"
        className="fill-emerald-500/10 stroke-emerald-500/40"
      />
      <text x="86" y="97.5" fontSize="19" fontWeight="500" className="fill-emerald-600">
        {t(`${COMPONENT}.api_access.response`)}
      </text>
      <circle cx="544" cy="90" r="19" className="fill-emerald-500" />
      <path
        d="M536 89l6 6 12-12"
        fill="none"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="stroke-white"
      />
      <g fontSize="24.2" className="fill-spark-text-secondary">
        {API_RESPONSE.map(({ line, indent }, row) => (
          <text key={line} x={indent ? 130 : 81} y={176 + row * 35}>
            {line}
          </text>
        ))}
      </g>
    </svg>
  );
}

export function InvoicesGraphic() {
  return (
    <svg viewBox="0 0 495 294" aria-hidden="true" className="select-none">
      <rect
        x="56.5"
        y="41"
        width="380"
        height="300"
        rx="6"
        strokeWidth="2"
        className="fill-spark-surface stroke-spark-border-default"
      />
      <InvoiceDocument transform="translate(55.5 40) scale(0.644)" />
    </svg>
  );
}
